module.exports = __webpack_public_path__ + "static/media/arrow-right.8c2e48ed.svg";